import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import admin from '../admin/reducer';
import feature from '../feature/reducer';
import modal from '../components/modal/reducer';
import request from '../util/requestReducer';
import toast from '../components/toast/reducer';
import tableServerSide from '../components/tableServerSide/reducer';
import user from '../user/reducer';
import notifications from '../notifications/reducer';

const combinedReducers = combineReducers({
  admin,
  feature,
  form,
  modal,
  notifications,
  request,
  tableServerSide,
  toast,
  user
});

export default combinedReducers;
